import {colors, makeStyles} from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

const themeConfigs = createTheme({
  overrides: {
    MuiInputBase: {
      input: {
        '&::placeholder': {
          opacity: 1,
          color: colors.blueGrey[600]
        }
      }
    },
  },
  palette: {
    type: 'light',
    action: {
      active: colors.blueGrey[600]
    },
    background: {
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#017AEF'
    },
    secondary: {
      main: '#5850EC'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },

    immersiongreen: {
      main: '#1CB858',
    },
    immersionred: {
      main: '#ED554A',
    },
    immersiongray: {
      main: '#8191A1',
    },
    knownsecondary: {
      main: '#fdca42'
    },
  },

  typography: {
    h1: {
      fontFamily: 'Suez One',
    },
  },

});

const useStylesTooltip = makeStyles(() => ({
  arrow: {
    color: '#6f6f6f'
  },
  tooltip: {
    backgroundColor: '#6f6f6f'
  }
}));

export {
  themeConfigs,
  useStylesTooltip
}